import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_DATA_SEARCH_CONTRACT_CONFIRM } from './constant/emptyData';

const initialState = {
    search: {
        ...EMPTY_DATA_SEARCH_CONTRACT_CONFIRM
    }
};

export const contractConfirmSlice = createSlice({
    name: 'contractConfirm',
    initialState,
    reducers: {
        searchContractConfirm: (state, action) => {
            state.search = action.payload;
        },
        searchContractConfirmPageFirst: (state, action) => {
            state.search.page = 1;
        },
    },
})


// Action creators are generated for each case reducer function
const { reducer, actions } = contractConfirmSlice;
export const { searchContractConfirm, searchContractConfirmPageFirst } = actions

export const selectSearchContractConfirm = (state) => state?.features?.contractConfirm?.search

export default reducer


